import { render } from "./DomainView.vue?vue&type=template&id=50985918&scoped=true"
import script from "./DomainView.vue?vue&type=script&lang=js"
export * from "./DomainView.vue?vue&type=script&lang=js"

import "./DomainView.vue?vue&type=style&index=0&id=50985918&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50985918"]])

export default __exports__